export interface HealthAppUser {
  name: string;
  surname1: string;
  surname2: string;
  birthdate: string;
  treatment: string;
  documentTypeId: string;
  address: {
    number: string;
    flat?: string;
    street: string;
    streetType: string;
    postalCode: string;
    city: string;
    province: string;
    floor: string;
  };
  documentCode?: string;
  documentType: string;
  documentNumber: string;
  phone: string;
  email: string;
  status: number;
  token: string;
  primeEnabled: boolean;
  userCode: string;
  policyAccepted: boolean;
  policyOTAccepted: boolean;
}
export interface HealthAppLoginRawResponse {
    client: HealthAppUser;
    token: string;
    nuuma?: string;
}

export interface HealthAppLoginResponse {
  jwtAccessToken: string;
  body: HealthAppUser;
}


export enum HealthAppOperationalAccess {
  AUTHORIZATION = 'authorization',
  REFUND = 'refund',
  APPOINTMENT_SCHEDULE = 'schedule_appointment',
  APPOINTMENTS = 'appointments',
  REPORTS_AND_ANALYTICS = 'reports_analytics',
  PERMISSIONS = 'permissions'
}

export enum HealthAppReceivedEventDataType {
  CLOSE_IFRAME = 'closeIframe',
  AUTH_REQUIRED = 'authRequired',
  ERROR = 'error',
  REGISTER_OPERATION = 'registerOperation',
  AUTHORIZATION_REQUEST_CORRECT = 'authorizationRequestCorrect',
  APPOINTMENT_CHANGE_SECTION = 'appointmentChangeSection',
  IFRAME_LOADED = 'iframeLoaded'
}
export interface HealthAppReceivedEventData {
  type: HealthAppReceivedEventDataType;
}

export interface HealthAppDispatchEventData {
  type: string;
  payload: unknown;
}
